export const SHARE_TEXTS_LOAD_REQUEST = 'SHARE_TEXTS_LOAD_REQUEST';
export const SHARE_TEXTS_LOAD_FAILURE = 'SHARE_TEXTS_LOAD_FAILURE';
export const SHARE_TEXTS_LOAD_SUCCESS = 'SHARE_TEXTS_LOAD_SUCCESS';
export const SHARE_EMAIL_DELETE_SUCCESS = 'SHARE_EMAIL_DELETE_SUCCESS';
export const SHARE_EMAIL_SAVE_SUCCESS = 'SHARE_EMAIL_SAVE_SUCCESS';
export const SHARE_SOCIAL_SAVE_SUCCESS = 'SHARE_SOCIAL_SAVE_SUCCESS';
